"use client";

import React from "react";

export function CardDetailsDialogSkeleton() {
  return (
    <div className="space-y-6">
      {/* CardImageText skeleton */}
      <div className="mx-auto grid max-w-full grid-cols-1 gap-2 sm:grid-cols-2 md:gap-4 lg:max-w-full">
        {/* Card image side */}
        <div className="flex items-center justify-center lg:justify-center">
          <div className="flex w-full flex-col items-center justify-center gap-2">
            <div className="skeleton aspect-[5/7] w-full rounded-lg"></div>

            {/* Market icons: Cardmarket button + CardActions button */}
            <div className="flex flex-row items-center justify-between gap-2">
              <div className="skeleton h-8 w-36 rounded-sm"></div>
              <div className="skeleton size-8 rounded-sm"></div>
            </div>
          </div>
        </div>

        {/* Card details side */}
        <div className="flex flex-col">
          <div className="flex flex-col gap-2">
            {/* Card name and mana cost */}
            <div className="mt-2 flex flex-row items-center justify-between gap-1 md:mt-0">
              <div className="skeleton h-7 w-3/4"></div>
              <div className="skeleton size-7 rounded-full"></div>
            </div>

            {/* Card type */}
            <div className="skeleton h-6 w-2/3"></div>

            {/* Oracle text */}
            <div className="space-y-1">
              <div className="skeleton h-4 w-full"></div>
              <div className="skeleton h-4 w-5/6"></div>
              <div className="skeleton h-4 w-4/5"></div>
            </div>

            {/* Flavor text */}
            <div className="skeleton h-4 w-1/2"></div>
          </div>

          {/* Divider */}
          <div className="my-2 border-t border-gray-300"></div>

          {/* CardSetPrice skeleton: set icon | set name + code | price + rarity */}
          <div className="flex items-center gap-2">
            <div className="flex-shrink-0">
              <div className="skeleton size-8 rounded-full"></div>
            </div>
            <div className="min-w-0 flex-grow">
              <div className="skeleton mb-1 h-4 w-24"></div>
              <div className="skeleton h-3 w-16"></div>
            </div>
            <div className="flex-shrink-0">
              <div className="flex flex-col items-end">
                <div className="skeleton mb-1 h-4 w-12"></div>
                <div className="skeleton h-3 w-14"></div>
              </div>
            </div>
          </div>

          {/* CardOwnershipRibbon skeleton */}
          <div className="mt-3">
            <div className="alert alert-soft alert-neutral gap-2 text-sm">
              <div className="skeleton size-[18px] shrink-0 self-start rounded"></div>
              <div className="flex flex-col items-start gap-1.5">
                <div className="skeleton h-5 w-32 rounded-full"></div>
                <div className="skeleton h-5 w-28 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CardDetailsPrintings skeleton */}
      <div className="flex flex-col">
        <div className="mb-1 flex items-center justify-between">
          <div className="skeleton h-6 w-32"></div>
          <div className="skeleton size-6 rounded"></div>
        </div>
        <div className="max-h-[33vh] space-y-2">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <div className="skeleton size-8 flex-shrink-0 rounded-full"></div>
              <div className="skeleton h-4 w-32 flex-grow"></div>
              <div className="skeleton h-4 w-16 flex-shrink-0"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Legalities section skeleton */}
      <section>
        <div className="divider"></div>
        <header>
          <div className="skeleton mb-1 mt-1 h-6 w-24"></div>
        </header>
        <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
          {Array.from({ length: 8 }).map((_, idx) => (
            <div key={idx} className="w-full p-1 sm:w-1/2">
              <div className="grid grid-cols-2 items-center gap-1 sm:grid-cols-3">
                <div className="skeleton col-span-1 h-6 rounded-sm sm:col-span-2"></div>
                <div className="skeleton h-4 w-16"></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Rulings section skeleton */}
      <section>
        <div className="divider my-4"></div>
        <header>
          <div className="skeleton mb-2 h-5 w-32"></div>
        </header>
        <div className="space-y-4 pb-4">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="flex flex-col space-y-1">
              <div className="skeleton h-4 w-24"></div>
              <div className="space-y-1">
                <div className="skeleton h-4 w-full"></div>
                <div className="skeleton h-4 w-4/5"></div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
